import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useRooms(enabled = true) {
  const navigate = useNavigate();

  const [rooms, setRooms] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRooms = useCallback(() => {
    if (!enabled) {
      return;
    }
    setLoading(true);
    quarkusApi
      .get('/rooms', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setRooms(returnFromApi.data ?? []))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [enabled, navigate]);

  useEffect(() => {
    fetchRooms();
  }, [fetchRooms]);

  return { rooms, isLoading, error, refetch: fetchRooms };
}
